<template>
  <v-dialog
    class="text-left"
    v-model="isOpenDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar class="fixed-bar" dark flat color="primary">
        <v-btn icon dark @click="closeDialog()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>Shop Information</v-toolbar-title>
      </v-toolbar>

      <v-skeleton-loader
        v-if="!isLoaded"
        type="image,list-item, divider, list-item, divider,list-item,divider,list-item,divider"
      ></v-skeleton-loader>

      <v-container v-if="isLoaded">
        <v-row class="grey lighten-3">
          <v-col cols="8">
            <h3 class="grey--text text--darken-3 h6">{{ shop.name }}</h3>
            <h3 class="grey--text text--darken-2 caption">
              {{ shop.area.name }},
              {{ shop.area.village.taluk.district.name }} -
              {{ shop.area.village.taluk.district.state.name }}
            </h3>
          </v-col>
        </v-row>

        <v-row class="mb-0">
          <v-col cols="4">
            <h3 class="grey--text body-2">Shop Code</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="7">
            <h3 class="grey--text text--darken-3 body-2">
              {{ shop.code }}
            </h3>
          </v-col>
        </v-row>

        <v-row class="mt-0 mb-0">
          <v-col cols="4">
            <h3 class="grey--text body-2">Address</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="7">
            <h3 class="grey--text text--darken-3 body-2">
              {{ shop.address1 }}, {{ shop.address2 }}
            </h3>
          </v-col>
        </v-row>

        <v-row v-if="shop.landmark != null" class="mt-0 mb-0">
          <v-col cols="4">
            <h3 class="grey--text body-2">Landmark</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="7">
            <h3 class="grey--text text--darken-3 body-2">
              {{ shop.landmark }}
            </h3>
          </v-col>
        </v-row>

        <v-row class="mt-0 mb-0">
          <v-col cols="4">
            <h3 class="grey--text body-2">Pin Code</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="7">
            <h3 class="grey--text text--darken-3 body-2">{{ shop.pincode }}</h3>
          </v-col>
        </v-row>

        <v-row class="mt-0 mb-0">
          <v-col cols="4">
            <h3 class="grey--text body-2">GST</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="7">
            <h3 class="grey--text text--darken-3 body-2">{{ shop.gst }}</h3>
          </v-col>
        </v-row>

        <v-row class="mt-0 mb-0" v-if="shop.distributor_id != null">
          <v-col cols="4">
            <h3 class="grey--text body-2">Distributor</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="7">
            <h3 class="grey--text text--darken-3 body-2">
              {{ shop.distributor.name }}
            </h3>
          </v-col>
        </v-row>

        <v-row class="mt-0 mb-0">
          <v-col cols="4">
            <h3 class="grey--text body-2">Phone No.</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="7">
            <h3 class="grey--text text--darken-3 body-2">{{ shop.phone }}</h3>
          </v-col>
        </v-row>
        <v-row class="mt-0 mb-0">
          <v-col cols="4">
            <h3 class="grey--text body-2">Email ID</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="7">
            <h3 class="grey--text text--darken-3 body-2">{{ shop.email }}</h3>
          </v-col>
        </v-row>
        <v-row class="mt-0 mb-0">
          <v-col cols="4">
            <h3 class="grey--text body-2">DOJ</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="7">
            <h3 class="grey--text text--darken-3 body-2">
              {{ moment(shop.date_of_join).format("MMM DD, YYYY") }}
            </h3>
          </v-col>
        </v-row>

        <v-row v-if="shop.remarks != null" class="mt-0 mb-0">
          <v-col cols="4">
            <h3 class="grey--text body-2">Remarks</h3>
          </v-col>
          <v-col cols="1"> : </v-col>
          <v-col cols="7">
            <h3 class="grey--text text--darken-3 body-2">{{ shop.remarks }}</h3>
          </v-col>
        </v-row>

        
          <div class="user-details text-center mt-4 mb-4">
            <h5 class="subtitle-2 grey--text text--darken-1 mb-4">
              User Details
            </h5>
            <div>
              <label
                style="width: 50%; display: inline-block"
                class="subtitle-2 grey--text text--darken-2 text-right pr-2"
                >Username :
              </label>
              <label
                style="width: 50%; display: inline-block"
                class="subtitle-2 grey--text text--darken-3 text-left pl-2"
                >{{ shop.user.name }}
              </label>
            </div>
            <div>
              <label
                style="width: 50%; display: inline-block"
                class="subtitle-2 grey--text text--darken-2 text-right pr-2"
                >Password :
              </label>
              <label
                style="width: 50%; display: inline-block"
                class="subtitle-2 grey--text text--darken-3 text-left pl-2"
              >
                <label v-if="showPassword">{{ shop.phone }}</label>
                <label v-if="!showPassword">●●●●●●●</label>
                <v-btn
                  style="top: -1px"
                  class="mx-2"
                  @click="showPassword = !showPassword"
                  icon
                  x-small
                  color="primary"
                >
                  <v-icon dark> mdi-eye </v-icon>
                </v-btn>
              </label>
            </div>
          </div>
       

       
          <v-btn
            block
            elevation="2"
            color="primary"
            @click="handleOpenDialog(shop.id)"
          >
            View Sales Details
          </v-btn>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["dialog", "id"],
  data() {
    return {
      showPassword: false,
      shop: {},
      isLoaded: false,
      shopDialog: false,
      current_shop: null,
    };
  },
  computed: {
    isOpenDialog() {
      return this.dialog;
    },
  },
  watch: {
    isOpenDialog(isOpen) {
      if (isOpen) {
        this.$api.getShopDetails({ id: this.id }).then(
          (response) => {
            if (response.data.status == "success") {
              this.shop = response.data.shop;
              this.isLoaded = true;
            }
          },
          (error) => {
            console.log(error);
          }
        );
      }
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update:dialog", false);
    },
    handleOpenDialog(shop) {
      this.current_shop = shop;
      this.$router.push("/" + shop + "/sales");
    },
  },
};
</script>

<style scoped>
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 0px;
  z-index: 2;
  border-radius: 0 !important;
}
.row {
  border-bottom: solid 1px #f1f1f1;
}
.user-details {
  padding: 10px;
  border-radius: 5px;
  background: #f1f1f1;
}
</style>
